// ========== Help Center Active Category | Desktop ==========
const helpCenterCategories = document.querySelectorAll(
    ".help-center__category"
);
const searchInput = document.getElementById("helpCenterSearchInput");

// Helper function

let activeCategory = null;
let searchQuery = "";

const resetMobileCategories = () => {
    const mobileContainer = document.querySelectorAll(
        ".help-center__category-container"
    );
    const mobileInnerContainer = document.querySelectorAll(
        ".help-center__mobile-questions"
    );

    mobileContainer.forEach((el) => {
        el.classList.remove("opened");
        el.style.display = "block";
    });

    mobileInnerContainer.forEach((el) => {
        el.style.display = "none";
    });
};

const resetSearch = () => {
    resetMobileCategories();
    const content = document.querySelectorAll(".help-center__content")[0];
    content.classList.remove("has-found-values", "has-search-query");
};

const resetActiveCategories = () => {
    resetSearch();
    const allRows = document.querySelectorAll(".help-center__row");
    const allCategoryTitles = document.querySelectorAll(
        ".help-center__sub-category-title"
    );
    const els = [...helpCenterCategories, ...allRows, ...allCategoryTitles];
    els.forEach((el) => el.classList.remove("active"));
};

const helpCenterActiveCategories = function (category) {
    if (window.innerWidth < 990) return;

    resetActiveCategories();

    activeCategory = category;

    const relatedRows = document.querySelectorAll(
        category.getAttribute("data-category")
    );

    category.classList.add("active");
    relatedRows.forEach((el) => el.classList.add("active"));
};

helpCenterCategories.forEach((category) => {
    activeCategory = category;
    category.addEventListener("click", function () {
        helpCenterActiveCategories(category);
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const activeCategoryOnLoad = document.querySelector(
        ".help-center__category.active"
    );
    helpCenterActiveCategories(activeCategoryOnLoad);
});

window.addEventListener("resize", function () {
    const activeCategorySelected = document.querySelector(
        ".help-center__category"
    )[0];

    helpCenterActiveCategories(
        activeCategory ? activeCategory : activeCategorySelected
    );
});

// ========== Help Center Accordion | Desktop & Mobile ==========
const helpCenterQuestions = document.querySelectorAll(".help-center__question");
const helpCenterRows = document.querySelectorAll(".help-center__row");

helpCenterQuestions.forEach((question) => {
    question.addEventListener("click", function () {
        const thisRow = question.closest(".help-center__row");
        const answerContainer = thisRow.querySelector(".help-center__answer");
        const answerHeight = getComputedStyle(
            answerContainer.querySelector(".help-center__answer-content")
        ).height;

        // 1) Opened class
        if (thisRow.classList.contains("opened")) {
            thisRow.classList.remove("opened");
        } else {
            helpCenterRows.forEach((el) => el.classList.remove("opened"));
            thisRow.classList.add("opened");
        }

        // 2) Answer Animation
        if (thisRow.classList.contains("opened")) {
            // Close all answers
            helpCenterRows.forEach(
                (el) =>
                    (el.querySelector(
                        ".help-center__answer"
                    ).style.maxHeight = 0)
            );
            // Open this answer
            answerContainer.style.maxHeight = answerHeight;
        } else {
            // Close this answer
            answerContainer.style.maxHeight = 0;
        }
    });
});

// Adjusct Answer Height on Resize
window.addEventListener("resize", function () {
    helpCenterQuestions.forEach((question) => {
        const thisRow = question.closest(".help-center__row");
        const answerContainer = thisRow.querySelector(".help-center__answer");
        const answerHeight = getComputedStyle(
            answerContainer.querySelector(".help-center__answer-content")
        ).height;

        if (thisRow.classList.contains("opened"))
            answerContainer.style.maxHeight = answerHeight;
    });
});

// ========== Help Center Show/Hide Questions | Mobile ==========
const helpCenterCategoriesRows = document.querySelectorAll(
    ".help-center__category-container"
);

helpCenterCategories.forEach((category) => {
    category.addEventListener("click", function () {
        activeCategory = category;
        if (window.innerWidth > 989) return;
        const thisRow = category.closest(".help-center__category-container");
        const mobileQuestions = thisRow.querySelector(
            ".help-center__mobile-questions"
        );

        // 1) Opened class
        if (thisRow.classList.contains("opened")) {
            thisRow.classList.remove("opened");
        } else {
            helpCenterCategoriesRows.forEach((el) =>
                el.classList.remove("opened")
            );
            thisRow.classList.add("opened");
        }

        // 2) Questions Show/Hide
        if (thisRow.classList.contains("opened")) {
            // Close all
            helpCenterCategoriesRows.forEach(
                (el) =>
                    (el.querySelector(
                        ".help-center__mobile-questions"
                    ).style.display = "none")
            );
            // Open this
            mobileQuestions.style.display = "block";
        } else {
            // Close this
            mobileQuestions.style.display = "none";
        }
    });
});

// Search functionality
function handleSearchQuery() {
    const questionNodes = document.querySelectorAll(".help-center__question");
    const questionEls = [...questionNodes];

    if (!questionEls.length) return;

    const questions = [];
    questionEls.forEach((el) => {
        const text = el.innerText.toLowerCase().trim();
        questions.push(text);
    });

    if (!searchQuery) {
        helpCenterActiveCategories(activeCategory);
        return;
    }

    let foundValues = false;

    let activeMobileContainers = [];
    let activeMobileInnerContainers = [];

    questions.forEach((value, i) => {
        const parent = questionEls[i].parentElement;
        const mobileContainer = parent.closest(
            ".help-center__category-container"
        );
        const mobileInnerContainer = parent.closest(
            ".help-center__mobile-questions"
        );

        if (value.includes(searchQuery)) {
            foundValues = true;

            const prevSibling = parent.previousElementSibling;

            if (prevSibling?.classList) {
                const prevSiblingSelector = prevSibling.classList.value
                    .split(" ")
                    .map((className) => `.${className}`)
                    .join("");
                const siblingTitles =
                    document.querySelectorAll(prevSiblingSelector);
                [...siblingTitles].forEach((el) => {
                    el.classList.add("active");
                });
            }

            parent.classList.add("active");

            if (mobileContainer) {
                activeMobileContainers.push(mobileContainer);
            }
            if (mobileInnerContainer) {
                activeMobileInnerContainers.push(mobileInnerContainer);
            }
        }
    });

    if (window.innerWidth < 990) {
        activeMobileContainers.forEach((el) => {
            el.classList.add("opened");
        });

        activeMobileInnerContainers.forEach((el) => {
            el.style.display = "block";
        });

        document
            .querySelectorAll(".help-center__category-container")
            .forEach((el) => {
                if (!el.classList.contains("opened")) {
                    el.style.display = "none";
                }
            });
    }

    const content = document.querySelectorAll(".help-center__content")[0];
    content.classList.add("has-search-query");
    content.classList[foundValues ? "add" : "remove"]("has-found-values");
}

const initiateSearch = () => {
    const handleChange = (e) => {
        resetActiveCategories();
        const searchValue = e.target.value.toLowerCase().trim();
        searchQuery = searchValue;
        handleSearchQuery();
    };

    searchInput.addEventListener("input", handleChange);
};

document.addEventListener("DOMContentLoaded", initiateSearch);
